import { faCar, faKey, faLock, faThumbtack } from '@fortawesome/free-solid-svg-icons';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Badge, Collapse, List, ListItemButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import { useAppSelector } from 'app/config/store';
import MenuItem from 'app/shared/layout/menus/menu-item';
import { showElement } from 'app/shared/util/data-utils';
import React from 'react';
import { Translate } from 'react-jhipster';

export interface ICompanyMenuProps {
  isAdmin: boolean;
  isManufacturerAdmin: boolean;
  isTransporterAdmin: boolean;
  isRepresentativeAdmin: boolean;
  index: number;
  onExpand: (index: number) => void;
  isExpanded: boolean;
  setOpen: (value: boolean) => void;
  drawerIsOpen: boolean;
}

export const CompanyMenu = ({
  isAdmin,
  isRepresentativeAdmin,
  isTransporterAdmin,
  isManufacturerAdmin,
  onExpand,
  isExpanded,
  index,
  drawerIsOpen,
  setOpen,
}: ICompanyMenuProps) => {
  const initialTheme = localStorage.getItem('USER_THEME') as 'light' | 'dark' | null;
  const delayedDeviceCommunicationsCount = useAppSelector(state => state.deviceCommunication.countAlt);

  return (
    <>
      <Tooltip title={drawerIsOpen ? '' : <Translate contentKey="global.menu.adminMenu">Administrator</Translate>} placement="right">
        <ListItemButton
          id="company-button"
          onClick={() => onExpand(index)}
          sx={{
            pl: { xs: '18px', md: '32px' },
            backgroundImage: isExpanded
              ? initialTheme === 'dark'
                ? 'linear-gradient(rgba(6, 13, 31, 0.9), rgba(6, 13, 31, 0.9))'
                : 'linear-gradient(rgb(226,226,226), rgb(226,226,226))'
              : 'none',
          }}
        >
          <ListItemIcon>
            <AccountCircleIcon />
          </ListItemIcon>
          <ListItemText
            primary={<Translate contentKey="global.menu.adminMenu">Administrator</Translate>}
            primaryTypographyProps={{
              fontWeight: isExpanded ? '600' : '400',
              fontSize: '14px',
            }}
            sx={{ opacity: open ? 1 : 0 }}
          />
          {isExpanded ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
      </Tooltip>

      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        {(isAdmin || isRepresentativeAdmin || isTransporterAdmin || isManufacturerAdmin) && (
          <List component="div" disablePadding onClick={() => setOpen(false)}>
            <MenuItem icon="layer-group" to="/truck-group" style={showElement(isAdmin || isTransporterAdmin || isManufacturerAdmin)}>
              <Translate contentKey="global.menu.entities.truckGroup" />
            </MenuItem>
            <MenuItem icon="road" to="/logistic-routes" style={showElement(isAdmin || isTransporterAdmin)}>
              <Translate contentKey="global.menu.entities..logisticRoute" />
            </MenuItem>
            <MenuItem icon="map" to="/virtual-fence-circle" style={showElement(isAdmin || isTransporterAdmin)}>
              <Translate contentKey="global.menu.entities.virtualFenceCircle" />
            </MenuItem>
            <MenuItem icon="exclamation-triangle" to="/alert" style={showElement(isAdmin || isTransporterAdmin)}>
              <Translate contentKey="global.menu.entities.sensorAlert" />
            </MenuItem>
            <MenuItem icon="asterisk" to="/device-communication" style={showElement(isAdmin)}>
              <Translate contentKey="global.menu.entities.deviceCommunication" />
            </MenuItem>
            <MenuItem icon="building" to="/company">
              <Translate
                contentKey={
                  isAdmin || isRepresentativeAdmin
                    ? 'global.menu.entities.companies'
                    : isManufacturerAdmin
                    ? 'global.menu.entities.representatives'
                    : 'global.menu.entities.company'
                }
              />
            </MenuItem>
            <MenuItem icon="chart-bar" to="/statistic-mark-line" style={showElement(isAdmin || isTransporterAdmin)}>
              <Translate contentKey="global.menu.entities.statisticMarkLine" />
            </MenuItem>

            <MenuItem icon={faCar} to="/vehicle-model" style={showElement(isAdmin)}>
              <Translate contentKey="global.menu.entities.vehicleModel" />
            </MenuItem>
            {/* <MenuItem icon={faThumbtack} to="/place" style={showElement(isAdmin || isTransporterAdmin)}>
              <Translate contentKey="global.menu.entities.pointsOfInterest" />
            </MenuItem> */}
            <MenuItem icon={faKey} to="/company-token" style={showElement(isAdmin)}>
              <Translate contentKey="global.menu.entities.companyToken" />
            </MenuItem>
            <MenuItem icon="users" to="/admin/user-management">
              <Translate contentKey="global.menu.admin.userManagement" />
            </MenuItem>
            <MenuItem icon={faLock} to="/block-screen" style={showElement(isAdmin)}>
              <Translate contentKey="fleetSenseApp.blockScreen.home.title" />
            </MenuItem>
            <MenuItem icon={faLock} to="/allowed-companies" style={showElement(isAdmin)}>
              <Translate contentKey="fleetSenseApp.allowedCompanies.home.title" />
            </MenuItem>
          </List>
        )}
      </Collapse>
    </>
  );
};
